import { render, staticRenderFns } from "./EmployeeOnboard.vue?vue&type=template&id=463be422&"
import script from "./EmployeeOnboard.vue?vue&type=script&lang=js&"
export * from "./EmployeeOnboard.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeOnboard.vue?vue&type=style&index=0&id=463be422&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports